import { css } from "@emotion/react";

import { Divider } from "components/shared/library/Divider";
import { Typography } from "components/shared/library/Typography";
import { PlanBadge } from "components/shared/ribbonPro/PlanBadge";

import { purple, white } from "constants/colors";

const style = {
  container: css({
    background: white,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 16,
    overflow: "hidden",
  }),
  wrapper: css({
    padding: 24,
    borderRadius: 16,
    width: "-webkit-fill-available",
  }),
  leftHeader: css({
    display: "flex",
    gap: 8,
    flexDirection: "column",
  }),
  title: css({
    display: "flex",
    gap: 8,
  }),
  header: css({
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    justifyContent: "space-between",
    alignItems: "center",
  }),
  divider: css({
    margin: "16px 0px",
  }),
  slider: css({
    display: "flex",
    gap: 16,
  }),
  line: css({
    backgroundColor: purple[600],
    height: 4,
    width: "100%",
    borderRadius: 100,
  }),
};

type Props = {
  title: string;
  description: string;
  LeftComponent?: React.ReactNode;
  children?: React.ReactNode;
};

export const RibbonProWidget = ({
  title,
  description,
  LeftComponent,
  children,
}: Props) => {
  return (
    <div css={style.container}>
      <div css={style.line} />
      <div css={style.wrapper}>
        <div css={style.header}>
          <div css={style.leftHeader}>
            <div css={style.title}>
              <PlanBadge plan="pro" />
              <Typography>{title}</Typography>
            </div>
            <div>
              <Typography weight="bold" size="M">
                {description}
              </Typography>
            </div>
          </div>
          {LeftComponent && LeftComponent}
        </div>
        {children && (
          <>
            <Divider customCss={style.divider} />
            {children}
          </>
        )}
      </div>
    </div>
  );
};
